/* ------------------------------------------------------------------
   LatestPosts.js — shared "Latest Posts" grid (public page + editor preview)
   3-col grid of the user's recent published posts (media tiles + platform
   icon badge). The moat: this content comes from posts the user published
   through Greatly Social.
------------------------------------------------------------------ */
import React from 'react';
import { getPlatformIcon, getPlatformColor } from '../dashboard/accounts/helpers/platformIcons';

const isVideo = u => /\.(mp4|mov|webm|m4v|avi)(\?|#|$)/i.test(u || '');
const mediaStyle = { width: '100%', height: '100%', objectFit: 'cover', display: 'block' };

// the helper keys Twitter as 'x'
const iconKey = p => (p === 'twitter' ? 'x' : p);

function PostTile({ post }) {
  const href = post.url || post.mediaUrl;
  const color = getPlatformColor(iconKey(post.platform));
  const video = isVideo(post.mediaUrl);

  const tile = (
    <div style={{ position: 'relative', paddingTop: '100%', borderRadius: 10, overflow: 'hidden', background: '#eef2f7' }}>
      {/* fallback layer (shows if media fails to load) */}
      <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <i className={getPlatformIcon(iconKey(post.platform))} style={{ fontSize: 24, color, opacity: 0.28 }} />
      </div>

      {/* media on top */}
      <div style={{ position: 'absolute', inset: 0 }}>
        {video
          ? <video src={`${post.mediaUrl}#t=0.1`} muted playsInline preload="metadata" style={mediaStyle} />
          : <img src={post.mediaUrl} alt="" loading="lazy" style={mediaStyle}
                 onError={e => { e.currentTarget.style.display = 'none'; }} />}
      </div>

      {/* play overlay for videos */}
      {video && (
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
          <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ borderLeft: '9px solid #fff', borderTop: '6px solid transparent', borderBottom: '6px solid transparent', marginLeft: 3 }} />
          </div>
        </div>
      )}

      {/* platform icon badge */}
      <span style={{
        position: 'absolute', bottom: 5, right: 5, width: 19, height: 19, borderRadius: '50%',
        background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 1px 3px rgba(0,0,0,0.35)',
      }}>
        <i className={getPlatformIcon(iconKey(post.platform))} style={{ fontSize: 11, color }} />
      </span>
    </div>
  );

  return href
    ? <a href={href} target="_blank" rel="noreferrer" style={{ display: 'block' }}>{tile}</a>
    : tile;
}

export default function LatestPosts({ posts, textColor, subColor }) {
  if (!posts || !posts.length) return null;
  return (
    <div style={{ width: '100%', marginTop: 28 }}>
      <div style={{ fontSize: 13, fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 10, textAlign: 'center', color: subColor || textColor || '#111', opacity: 0.85 }}>
        Latest posts
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
        {posts.map((p, i) => <PostTile key={i} post={p} />)}
      </div>
    </div>
  );
}
